module.exports = __webpack_public_path__ + "static/img/ravine.64fcb6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/compressed/drawing_painting/ravine.jpg
// module id = /R2w
// module chunks = 1